import { render, staticRenderFns } from "./project-type-8.html?vue&type=template&id=13f3952c&scoped=true&external"
import script from "./project-type-8.js?vue&type=script&lang=js&external"
export * from "./project-type-8.js?vue&type=script&lang=js&external"
import style0 from "./project-type-8.scss?vue&type=style&index=0&id=13f3952c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f3952c",
  null
  
)

export default component.exports